<f-legend
  [data]="makeLegend.data"
  [contentAlignment]="makeLegend.legendContentAlignment!"
  [itemMarginSize]="makeLegend.legendItemsMarginSize"
  [wrappingLinesCount]="makeLegend.legendWrappingLinesCount!"
  class="w-100 body-50 mt-4"
>
</f-legend>
